import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';

@Pipe({
    name: 'ddMMYYYYDate',
    standalone: false
})
export class DdMmYyyyDatePipe extends DatePipe implements PipeTransform{
    override transform(value: any):any{
        return super.transform(value, 'dd/MM/YYYY');
    }
}